import React from 'react';
import { useTranslation } from 'react-i18next';

import { getFaqLink } from 'helpers/getFaqLink';
import { Text } from 'components/library';
import * as S from './styled';
import { getLanguage } from 'api/utils/languageManagment';
import { getDeviceOS } from 'helpers/utils';

const lang = getLanguage();
const deviceOs = getDeviceOS();

const SubscriptionHelpButton = () => {
    const { t } = useTranslation();

    return (
        <S.HelpButton>
            <Text type="medium-text" bold>
                {t('subscription.helpButton.question')}
            </Text>
            <S.FaqLink as="a" href={getFaqLink(lang, deviceOs)} target="_blank" data-locator="faqButton">
                <Text type="caption" color="on-primary" bold>
                    {t('subscription.helpButton.faq')}
                </Text>
            </S.FaqLink>
        </S.HelpButton>
    );
};

export default SubscriptionHelpButton;
